import { Component, inject, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './south-dakota-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { RequestService } from '../../../_services/request/request.service';
import { UimuiBaseRulesService } from '../services/uimui-base-rules.service';
import {
  CoverageType,
  LimitType,
  StackType,
  UIUMSelectionType,
} from '../../../config/constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-south-dakota',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './south-dakota.component.html',
})
export class SouthDakotaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  requestService = inject<RequestService>(RequestService);

  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('south-dakota', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('south-dakota', null);
    }
  }

  override baseRuleQueryBuilder() {
    if (this.baseRulesService.getNonGarageStates().includes(this.state)) {
      return this.baseRulesService.states.find((s) => s.state === this.state)
        ?.defaultQuery;
    }
    const liabilityLimit =
      this.requestService.getLiabilityLimitForState('south-dakota');
    let limitValue = liabilityLimit;
    limitValue = Number(liabilityLimit.replace(/[$,]/g, ''));

    const UIUMSelectionType_ = {
      RejectWhenPossible: 'RejectWhenPossible',
      StateMinimum: 'StateMinimum',
    };
    const selectionTypeKey = this.baseRulesService.selectionTypeKey;

    if (
      limitValue <= 100000 &&
      (selectionTypeKey === UIUMSelectionType_.RejectWhenPossible ||
        selectionTypeKey === UIUMSelectionType_.StateMinimum)
    ) {
      return 'SelectionId_Under100K';
    }

    return undefined;
  }
}
